import React from 'react';
import { LoadingSpinner } from '../../../components/LoadingSpinner';

interface PropTypes {
  redacted: boolean;
  minHeight?: string;
}

export function RedactingLoadingState(props: PropTypes) {
  return (
    <LoadingSpinner
      minHeight={props.minHeight}
      message={
        props.redacted ? 'Redacting candidate data from the CV...' : null
      }
    />
  );
}
